const initialState: any = {
  dashLayoutHeading: undefined,
};

export const headingReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case 'SET_DASH_LAYOUT_HEADING':
      return {
        ...state,
        dashLayoutHeading: action.payload,
      };

    default:
      return state;
  }
};
